// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__wQtcI","head":"ProcedureTableInfo_head__3FfCP"};